<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <!--          <el-form-item label="开始日期" prop="startDate">-->
          <!--            <el-date-picker-->
          <!--              v-model="queryParams.startDate"-->
          <!--              type="date"-->
          <!--              placeholder="选择日期"-->
          <!--              value-format="yyyy-MM-dd"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            />-->
          <!--          </el-form-item>-->

          <el-form-item label="日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>通过率分布</span>
        </div>

        <el-table
          :data="headerData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          >
            <template scope="scope">
              {{ dateStrTodate(scope.row.date) }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in levelData"
            :key="index"
            :label="'等级'+item.level"
            align="center"
          >
            <el-table-column
              label="过这关人数"
              align="center"
              width="150"
            >
              <template scope="scope">{{ tableData[scope.row.date][item.level].LevelAfter }}</template>
            </el-table-column>
            <el-table-column
              label="到这关人数"
              align="center"
              width="150"
            >
              <template scope="scope">{{ tableData[scope.row.date][item.level].LevelBefore }}</template>
            </el-table-column>
            <el-table-column
              label="通过率"
              align="center"
              width="100"
            >
              <template scope="scope">{{ tableData[scope.row.date][item.level].Rate }}%</template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <upLevelRateAvg ref="rate" />
      </el-row>

      <el-row :gutter="12">
        <upLevelRateAvg ref="after" k="LevelAfter" title="过这关人数" />
      </el-row>

      <el-row :gutter="12">
        <upLevelRateAvg ref="before" k="LevelBefore" title="到这关人数" />
      </el-row>

      <!--      <el-row :gutter="12">-->
      <!--        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
      <!--          <upLevelAvg ref="dayAvgCount" />-->
      <!--        </el-col>-->
      <!--        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
      <!--          <upLevelAvg ref="avg" :typ="2" :title="'人均通关次数'" />-->
      <!--        </el-col>-->
      <!--      </el-row>-->

    </template>
  </BasicLayout>
</template>

<script>
import { getUserUpLevelStat } from '@/api/user/user_info'
import upLevelRateAvg from '@/views/config/up-level-stat/components/uplevel-level-stat.vue'
import { getLastDates, dateStrTodate, scientificFormat } from '@/utils'
export default {
  name: 'UpLevelCountStat',
  components: {
    upLevelRateAvg
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: [],
      levelData: [],
      headerData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables()
  },
  methods: {
    dateStrTodate,
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getUserUpLevelStat(this.queryParams).then(res => {
        if (res.code === 200) {
          const { data, maxLevel } = res.data
          for (let i = 1; i <= maxLevel; i++) {
            this.levelData.push({ level: i })
          }

          for (const i in data) {
            const val = data[i]
            this.headerData.push({ date: val.date })
            this.tableData[val.date] = val.data
          }

          this.$refs.rate.refresh(this.headerData, this.tableData)
          this.$refs.after.refresh(this.headerData, this.tableData)
          this.$refs.before.refresh(this.headerData, this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
